// extracted by mini-css-extract-plugin
export default {"empty":"styles__empty___obCrY","emptyTitle":"styles__emptyTitle___3ReU1"};